import React, { FC, ReactNode } from 'react';
import { BlurredContentContainer } from './styled-components';

interface BlurredContentProps {
  children: ReactNode;
}

export const BlurredContent: FC<BlurredContentProps> = ({ children }) => (
  <BlurredContentContainer>{children}</BlurredContentContainer>
);
